/* =================== CAMPO DO FORMULÁRIO REPRESENTANTE =================== */
  $("#sim-mercado").on("click", function(){
    var opcao = $("input[name='trabalha_atualmente']");
      opcao.prop('disabled', false);
      opcao.prop('required', true);
      opcao.removeClass('cursor-desabilitado');
      opcao.addClass('cursor-habilitado');
  });

  $("#nao-mercado").on("click", function(){
    var opcao = $("input[name='trabalha_atualmente']");
      opcao.prop('disabled', true);
      opcao.prop('required', false);
      // opcao.removeProp('required');
      opcao.removeClass('cursor-habilitado');
      opcao.addClass('cursor-desabilitado');
  });

